module.exports = __webpack_public_path__ + "static/media/data-security.4cd86e34.svg";